var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", {
        attrs: {
          title: _vm.$t("account.profile.email.confirm"),
          showPrevButton: false,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _vm.objectError !== null
                ? _c("div", { staticClass: "box" }, [
                    _c(
                      "div",
                      { staticClass: "form-message form-message--error" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.objectError) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.objectSuccess !== null
                ? _c("div", { staticClass: "box" }, [
                    _c(
                      "div",
                      { staticClass: "form-message form-message--success" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.objectSuccess) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }